customElements.define("x-checkout", class Checkout extends HTMLElement {
  private _brands = null;
  private _checkoutId = null;
  private _endpoint = null;
  private _shopperResultUrl = null;
  private _locale = null;

  public get locale() {
    return this._locale;
  }

  public set locale(newLocale) {
    if (this._locale !== null) {
      console.warn("property `locale' can only be set initially, ignoring");
    }
    this._locale = newLocale;
  }

  public get endpoint() {
    return this._endpoint;
  }

  public set endpoint(newEndpoint) {
    if (this._endpoint !== null) {
      console.warn("property `endpoint' can only be set initially, ignoring");
    }
    this._endpoint = newEndpoint;
  }

  public get checkoutId() {
    return this._checkoutId;
  }

  public set checkoutId(newCheckoutId) {
    if (this._checkoutId !== null) {
      console.warn("property `checkoutId' can only be set initially, ignoring");
    }
    this._checkoutId = newCheckoutId;
  }

  public get brands() {
    return this._brands;
  }

  public set brands(newBrands) {
    if (this._brands !== null) {
      console.warn("property `brands' can only be set initially, ignoring");
    }
    this._brands = newBrands;
  }

  public get shopperResultUrl() {
    return this._shopperResultUrl;
  }

  public set shopperResultUrl(newShopperResultUrl) {
    if (this._shopperResultUrl !== null) {
      console.warn("property `shopperResultUrl' can only be set initially, ignoring");
    }
    this._shopperResultUrl = newShopperResultUrl;
  }

  constructor() {
    super()
  }

  connectedCallback() {
    this._shadowRoot = this.attachShadow({ mode: "closed" })

    const slot = document.createElement("slot");
    slot.setAttribute("name", "form");
    this._shadowRoot.appendChild(slot);

    const form = document.createElement("form")
    form.action = this._shopperResultUrl
    form.classList.add("paymentWidgets")
    form.dataset.brands = this._brands

    const formWrapper = document.createElement("div");
    formWrapper.setAttribute("slot", "form");
    formWrapper.appendChild(form);
    this.appendChild(formWrapper);

    const script = document.createElement("script")
    script.textContent = `
      var wpwlOptions = {
          locale: "${this.locale}",
      }
    `;
    document.head.appendChild(script);

    const paymentWidgets = document.createElement("script")
    paymentWidgets.src = `${this._endpoint}v1/paymentWidgets.js?checkoutId=${this._checkoutId}`
    document.head.appendChild(paymentWidgets);
  }

  disconnectedCallback() {
  }
})
